import { jsx as _jsx } from "react/jsx-runtime";
export const BlockConditionalRendering = ({ component: Component, componentProps = {}, data, shouldDisplay, }) => {
    if (!(shouldDisplay === null || shouldDisplay === void 0 ? void 0 : shouldDisplay({ data }))) {
        return null;
    }
    return _jsx(Component, Object.assign({}, componentProps));
};
//# sourceMappingURL=index.js.map